/**
 * The tab id for one style in the order's products pane (AB#22168).
 *
 * The pane built it as `product.id.toString()`. A style stored without an id
 * (order 27938 had four, `"id": null`) threw there, and with no error handler
 * the whole pane rendered blank. Fall back to the style's position so the
 * order still opens; the stored id itself is never invented here.
 */
export const factoryProductTabId = (product: { id?: unknown } | null | undefined, index: number): string => {
  const id = product?.id;
  return id === null || id === undefined || String(id).trim() === '' ? `style-${index}` : String(id);
};
